import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";

export const RidePassengerTooltipWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "ride-passenger-tooltip",
})`
  .ride-passenger-tooltip__list {
    list-style: none;
    margin: 0;
    padding: 0;
    text-align: left;
    max-width: 480px;
  }

  .ride-passenger-tooltip__row {
    display: block;
    line-height: 1.45;
    white-space: normal;
    overflow-wrap: break-word;
    word-break: normal;
  }

  .ride-passenger-tooltip__row--title {
    font-weight: 600;
  }

  .ride-passenger-tooltip__station-suffix {
    white-space: nowrap;
    unicode-bidi: isolate;
  }
`;
